export default function Droplet() {
  return (
    <svg
      width="38"
      height="57"
      viewBox="0 0 38 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Droplet icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 53C10.7251 53 4 46.2534 4 37.902C4 35.9804 4.90904 32.8852 6.50121 29.0805C8.0575 25.3615 10.1465 21.2361 12.2559 17.3671C14.3619 13.5045 16.4704 9.92978 18.0538 7.31879C18.3957 6.75507 18.7128 6.23664 19 5.77034C19.2871 6.23665 19.6042 6.75508 19.9461 7.31879C21.5295 9.92978 23.638 13.5045 25.744 17.3671C27.8534 21.2361 29.9425 25.3615 31.4988 29.0805C33.091 32.8852 34 35.9804 34 37.902C34 46.2527 27.2665 53 19 53ZM19 2C17.3173 0.9189 17.3172 0.919132 17.317 0.919468L17.2658 0.999477C17.2326 1.05133 17.1839 1.12775 17.1206 1.22739C16.9941 1.42667 16.8093 1.71891 16.5747 2.09347C16.1054 2.84251 15.4361 3.92127 14.6336 5.24464C13.0295 7.88976 10.888 11.5199 8.74401 15.4524C6.60343 19.3785 4.44247 23.6384 2.81128 27.5363C1.21596 31.3486 0 35.1019 0 37.902C0 48.4409 8.4944 57 19 57C29.4958 57 38 48.4416 38 37.902C38 35.1019 36.784 31.3485 35.1887 27.5363C33.5575 23.6384 31.3965 19.3785 29.2559 15.4524C27.1119 11.5199 24.9704 7.88976 23.3663 5.24464C22.5638 3.92126 21.8946 2.84251 21.4252 2.09346C21.1906 1.7189 21.0058 1.42667 20.8793 1.22739C20.8414 1.1678 20.8088 1.11652 20.7816 1.07383C20.7633 1.04513 20.7475 1.02032 20.7342 0.999474L20.6829 0.919464C20.6827 0.919128 20.6826 0.918896 19 2ZM19 2L20.6829 0.919464C20.315 0.346783 19.6807 0 19 0C18.3193 3.8147e-06 17.6849 0.346786 17.317 0.919468L19 2Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 45C15.0686 45 13 43.0612 13 40C13 38.8954 12.1046 38 11 38C9.89543 38 9 38.8954 9 40C9 44.669 12.3026 49 17 49C18.1046 49 19 48.1046 19 47C19 45.8954 18.1046 45 17 45Z"
        fill="#231F20"
      />
    </svg>
  );
}
